import axios from 'axios';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { RestApiState } from './Organization';


interface RequestProps {
    role: string;
    organization_id: string;
    setter: (value: any) => void
}

export type DeviceType = {
    id: number
    device_name: string;
    organization: string;
}

export const FetchDeviceList =  async ({ role, organization_id, setter }: RequestProps) => {
    axios.get<DeviceType[]>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/organization/${organization_id}/devices/list`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            try {
                setter(response.data)
            } catch {
                console.log('err')
            }
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}




interface CreateRequestProps {
    role: string;
    setStatus: (value: any) => void;
    setValue: (value: any) => void;
    data: {
        device_name: string;
        organization: string;
    };
}


export const CreateDevice = async ({ role, setStatus, setValue, data }: CreateRequestProps) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.post<DeviceType>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/devices/create`, data, headers
    )
    .then(response => {
        if (response.status === 201) {
            setStatus(RestApiState.Success)
            setValue(response.data)
        }
    })
    .catch(error => {
        setStatus(error.status)
        // restErrorHandler(error.status)
    });
}

interface UpdateRequestProps {
    role: string;
    setStatus: (value: any) => void;
    setValue: (value: any) => void;
    device: DeviceType;
}

export const UpdateDevice = ({ role, setStatus, setValue, device }: UpdateRequestProps) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }

    axios.patch<DeviceType>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/devices/${device.id}/details`, device, headers)
        .then(response => {
            if (response.status === 200) {
                try {
                    setStatus(RestApiState.Success)
                    setValue(response.data)
                } catch {
                    console.log('err')
                }
            }
        })
        .catch(error => {
            setStatus(RestApiState.BadRequest)
            // restErrorHandler(error.status)
        });
}

interface DeleteRequestProps {
    role: string;
    setStatus: (value: any) => void;
    setValue: (value: any) => void;
    id: number;
}

export const AxiosDeleteDevice = ({ role, setStatus, setValue, id }: DeleteRequestProps) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.delete<DeviceType[]>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/devices/${id}/details`, headers
    )
    .then(response => {
        if (response.status === 204) {

            setStatus(RestApiState.Success)
            setValue(id)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}